var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"featuredUsersNote"},[_vm._v(" "+_vm._s(_vm.description)+" "),(_vm.isJapanese)?_c('HelpSiteLink',{staticClass:"featuredUsersNote__help",attrs:{"url":_vm.url}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }